import { Button, useTheme } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router";

export default function PageNotFound() {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="text-center">
        <p className="font-bold font-san text-[70px]">OOPS!</p>
        <p className="font-bold">Error 404: Page Not Found</p>
        <Button
          sx={{
            backgroundColor: theme.palette.buttonHover.main,
            "&:hover": {
              backgroundColor: theme.palette.buttonHover.secondary,
            },
            color: theme.palette.white.main,
            textTransform: "none",
            marginTop: 2,
          }}
          onClick={() => navigate(-1)}
        >
          GO BACK
        </Button>
      </div>
    </div>
  );
}
